import { apiClient } from './client';

export type NotificationKind =
  | 'agreement_signed'
  | 'agreement_unsigned'
  | 'booking_request'
  | 'repair_request'
  | 'payment_received'
  | 'report_published'
  | 'appointment_upcoming';

export interface Notification {
  id: string;
  userId: string;
  kind: NotificationKind;
  payload: Record<string, unknown>;
  linkPath: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  unreadCount: number;
}

export const notificationsApi = {
  list: async (opts: { limit?: number; before?: string } = {}): Promise<NotificationsResponse> => {
    const params = new URLSearchParams();
    if (opts.limit) params.set('limit', String(opts.limit));
    if (opts.before) params.set('before', opts.before);
    const qs = params.toString();
    const res = await apiClient.get<{ success: true; data: NotificationsResponse }>(
      `/notifications${qs ? `?${qs}` : ''}`,
    );
    if (!res.success) throw new Error((res as unknown as { error: string }).error);
    return res.data;
  },

  markRead: async (id: string): Promise<void> => {
    await apiClient.post<{ success: true }>(`/notifications/${id}/read`, {});
  },

  markAllRead: async (): Promise<{ marked: number }> => {
    const res = await apiClient.post<{ success: true; data: { marked: number } }>(
      '/notifications/read-all',
      {},
    );
    if (!res.success) throw new Error((res as unknown as { error: string }).error);
    return res.data;
  },
};
